import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import LearningDifficultyResponseViewModel from '../ViewModels/LearningDifficultyResponseViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface ILearningDifficultyResponseDropDownProps {
    setLearningDifficultyResponse?: (event) => void;
    learningDifficultyResponse: string | undefined;
    disabled: boolean;
    childMode: boolean;
}

interface ILearningDifficultyResponseDropDownState {
    model: LearningDifficultyResponseViewModel[];
    loaded: boolean;
}

class LearningDifficultyResponseDropDown extends Component<ILearningDifficultyResponseDropDownProps & WithStyles<typeof styles>, ILearningDifficultyResponseDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetLearningDifficultyResponses?childMode=' + this.props.childMode).then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultLearningDifficultyResponseVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={this.props.childMode ? "Do you consider your child to have a learning difficuty and/or disability and/or a health problem and/or a medical problem? *"
                    : "Do you consider yourself to have a learning difficuty and/or disability and/or a health problem and/or a medical problem? *"}
                name="learningDifficultyDisabilityResponse"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.learningDifficultyResponse}
                onChange={this.props.disabled ? undefined : this.props.setLearningDifficultyResponse}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(LearningDifficultyResponseDropDown);